import {KeysThatHaveType} from '../types';
import {stringifyClass} from 'webcommon/shared/object-utils-ng1520';

const patchFnKey = '_apPatchObjectFn';

// Patches the object fn
// throws an error if trying to patch multiple times
// Returns a teardown function to unpatch
// eslint-disable-next-line @typescript-eslint/ban-types
export function patchObjectFn<T extends object | Function, K extends KeysThatHaveType<T, (...args: any[]) => any>>(
  target: T,
  key: K,
  patchFn: (originalFn: T[K]) => T[K],
): () => void {
  type TKFn = T[K] extends (...args: any[]) => any ? T[K] : never;
  const originalFn = target[key] as TKFn;
  if (!originalFn) {
    throw new Error(`Could not apply patchObjectFn to ${stringifyClass(target)}.${key.toString()} because of an invalid value`);
  }
  if (isPatched(originalFn)) {
    throw new Error(`Could not apply patchObjectFn to ${stringifyClass(target)}.${key.toString()} because it was already patched`);
  }

  const newFn = patchFn(originalFn.bind(target));
  (newFn as any)[patchFnKey] = true;
  const teardownFn = Object.prototype.hasOwnProperty.call(target, key) ?
    () => {
      target[key] = originalFn;
    } :
    () => {
      if (!delete target[key]) {
        target[key] = originalFn;
      }
    };

  target[key] = newFn;

  return teardownFn;
}

export function isPatched(fn: (...args: any[]) => any): boolean {
  return !!(fn as any)[patchFnKey];
}



// this is what jasmine does, like if you're patching something on the prototype, then the teardown
// would normally be to just delete the patch
// not put the prototype method on the object itself to replace the patch
// in alot of cases it won't matter, but this is more correct,

// from node_modules/jasmine-core/lib/jasmine-core/jasmine.js
// spyOn implementation

//       var originalMethod = obj[methodName],
//         spiedMethod = j$.createSpy(methodName, originalMethod),
//         restoreStrategy;
//
//       if (Object.prototype.hasOwnProperty.call(obj, methodName) || (obj === global && methodName === 'onerror')) {
//         restoreStrategy = function() {
//           obj[methodName] = originalMethod;
//         };
//       } else {
//         restoreStrategy = function() {
//           if (!delete obj[methodName]) {
//             obj[methodName] = originalMethod;
//           }
//         };
//       }
//
//       currentSpies().push({
//         restoreObjectToOriginalState: restoreStrategy
//       });
//
//       obj[methodName] = spiedMethod;
//
//       return spiedMethod;
